import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge only knows the stock font-size names (text-xs/sm/base/…), so
// it classified our custom type-scale tokens (text-caption, text-2xs, …) as
// text COLORS. Any real color merged earlier in a cn() call was then dropped
// as a "conflict" — e.g. Button's `text-canvas` + size `text-caption` rendered
// primary labels in the inherited (dark) color on the dark fill: invisible.
// Registering the scale from tailwind.config.ts `fontSize` fixes the grouping.
// Same story for the other custom utility names: unregistered, tailwind-merge
// misfiles them (shadow-card/window parsed as shadow COLORS, so
// `cn('shadow-card','shadow-none')` kept both and the shadow never cleared;
// duration-modal / ease-out-strong simply never merged with stock values).
// Every custom name added to tailwind.config.ts MUST be registered here.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'eyebrow',
            '2xs',
            'caption',
            'body',
            'body-lg',
            'body-xl',
            'title',
            'title-lg',
            'head',
            'head-lg',
            'display-md',
            'display-lg',
            'display-xl',
          ],
        },
      ],
      shadow: [{ shadow: ['card', 'window'] }],
      duration: [{ duration: ['press', 'tooltip', 'popover', 'modal'] }],
      ease: [{ ease: ['out-strong', 'in-out-strong', 'drawer'] }],
      z: [{ z: ['sticky', 'now', 'bar', 'float', 'overlay', 'celebrate'] }],
      // font-display (the v4 Literata face) would otherwise be misfiled as a
      // font-WEIGHT and drop/duplicate against font-medium etc.
      'font-family': [{ font: ['display'] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
